import React from 'react';
import HomeIcon from '@material-ui/icons/Home';
import { NavItem } from './NavItem';

interface TabNavProps {
  tabId: string;
}

export const TabNav = ({ tabId }: TabNavProps) => (
  <NavItem icon={HomeIcon} text="Home" to={`${tabId}/home`} />
);
